import React from "react";
import { Link } from "react-router-dom";
import bg5 from "../../assets/images/background/bg-5.png";
import bg6 from "../../assets/images/background/bg-6.png";
import toronto from "../../assets/images/resource/toronto.png";
import paris from "../../assets/images/resource/paris.png";
import dubai from "../../assets/images/resource/dubai.png";
import ny from "../../assets/images/resource/ny.png";

function Book() {
  return (
    <>
      <section className="online-reservation inner-page">
        <div className="left-bg">
          <img src={bg5} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg6} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>Reservation</span>
            </div>
            <div className="pattern-image">
              <img
                src={require("../../assets/images/icons/separator.svg").default}
                alt=""
                title=""
              />
            </div>

            <h2>Book A Table</h2>
            <div className="text desc">
              Restaurant will be open for all days, Sunday night will be closed,
              All booking payment is secured with credit card, no charges will
              be aplly for online booking. no refundable.
            </div>
            <div className="text request-info">
              Booking request <Link to="#">+88-123-123456</Link> or fill out the
              order form
            </div>
          </div>
          <div className="default-form reservation-form">
            <form method="post" action="/">
              <div className="row clearfix">
                <div className="form-group col-lg-4 col-md-6 col-sm-12">
                  <div className="field-inner">
                    <span className="alt-icon far fa-user"></span>
                    <select className="l-icon">
                      <option>1 Person</option>
                      <option>2 Person</option>
                      <option>3 Person</option>
                      <option>4 Person</option>
                      <option>5 Person</option>
                      <option>6 Person</option>
                      <option>7 Person</option>
                    </select>
                    <span className="arrow-icon far fa-angle-down"></span>
                  </div>
                </div>
                <div className="form-group col-lg-4 col-md-6 col-sm-12">
                  <div className="field-inner">
                    <span className="alt-icon far fa-calendar"></span>
                    <input
                      className="l-icon datepicker"
                      type="text"
                      name="fieldname"
                      value=""
                      placeholder="DD-MM-YYYY"
                      required
                      readOnly
                    />
                    <span className="arrow-icon far fa-angle-down"></span>
                  </div>
                </div>
                <div className="form-group col-lg-4 col-md-12 col-sm-12">
                  <div className="field-inner">
                    <span className="alt-icon far fa-clock"></span>
                    <select className="l-icon">
                      <option>08 : 00 am</option>
                      <option>09 : 00 am</option>
                      <option>10 : 00 am</option>
                      <option>11 : 00 am</option>
                      <option>12 : 00 pm</option>
                      <option>01 : 00 pm</option>
                      <option>02 : 00 pm</option>
                      <option>03 : 00 pm</option>
                      <option>04 : 00 pm</option>
                      <option>05 : 00 pm</option>
                      <option>06 : 00 pm</option>
                      <option>07 : 00 pm</option>
                      <option>08 : 00 pm</option>
                      <option>09 : 00 pm</option>
                      <option>10 : 00 pm</option>
                    </select>
                    <span className="arrow-icon far fa-angle-down"></span>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="theme-btn btn-style-one clearfix"
              >
                <span className="btn-wrap">
                  <span className="text-one">book a table</span>
                  <span className="text-two">book a table</span>
                </span>
              </button>
            </form>
            <div className="powered-by">*Powered by OpenTable</div>
          </div>
        </div>

        <div className="map-location-section">
          <div className="auto-container">
            <div className="outer-box">
              <div className="row clearfix">
                <div className="reserv-col col-lg-8 col-md-12 col-sm-12">
                  <div className="inner">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.8902011416335!2d90.39918577602519!3d23.858032384634434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c4278a881ab3%3A0xf75dff14e42c6bd8!2s1%20Rd%20No%208%2C%20Dhaka%201230!5e0!3m2!1sen!2sbd!4v1730497722850!5m2!1sen!2sbd"
                      width="100%"
                      height="600"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
                <div className="info-col col-lg-4 col-md-12 col-sm-12">
                  <div className="inner">
                    <div className="title">
                      <h2>New York</h2>
                    </div>
                    <div className="data">
                      <ul className="info">
                        <li>
                          <strong>Contact Us</strong>
                          <br />
                          Xinxian Restaurant, Uttara,
                          <br /> House No. 1, Road No. 8, Sector-1, Uttara Model
                          Town, Dhaka-1230.
                          <br /> Call : 01755636266, 024895805 <br /> Web :
                          xinxian-uttara.x-grouprestaurant.com{" "}
                        </li>
                        <div className="separator">
                          <span></span>
                        </div>
                        <li>
                          <strong>Lunch Time</strong>
                          <br />
                          12:00 pm - 3:00 pm
                        </li>
                        <li>
                          <strong>Dinner Time</strong>
                          <br />
                          6:00 pm - 10:30 pm
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="location-center">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Uttara</h4>
                  <div className="text">
                    House No. 1, Road No. 8, Sector-1, Uttara Model Town,
                    Dhaka-1230 <br />
                    Call: 01755636266, 0248958051
                    <br />
                    Web: xinxian-uttara.x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xiamen Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House No. 55 A, Road No. 4 A (New), Satmasjid Road
                    Dhanmondi, Dhaka-1209. <br />
                    Call: +8801755636260, +88 02 58617163
                    <br />
                    Mail: xiamen@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Golden Chimney Restaurant, Banglamotor</h4>
                  <div className="text">
                    80/14/A Mymensingh Road (old), Sonargaon Road (new) 12,
                    Sonartori Tower, Dhaka-1000
                    <br />
                    Call: 01755636261, 02223363969
                    <br />
                    Mail: golden.chm@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xindian Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House no. 55, 55/A (new), 273 (old) Road no. 16 (new), 27
                    (old) Dhanmondi, Dhaka -1209
                    <br />
                    0258150396, 01755636262
                    <br />
                    xindian@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House no. 7, Road no. 8 Dhanmondi, Dhaka -1205
                    <br />
                    01755636263, 04478778843
                    <br />
                    xinxian.dhan@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Four Seasons Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House No. 59 A, Road No. 16 (new), 27 (old) Satmasjid Road,
                    Dhanmondi, Dhaka-1209
                    <br />
                    01755636264, 0241020520_21
                    <br />
                    4seasons@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Mirpur-10</h4>
                  <div className="text">
                    6/C, 8/11, Mirpur-11, Dhaka
                    <br />
                    01755636265, 0248032146
                    <br />
                    xinxian.mirpur@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Chung Wah Restaurant, Bijoy Nagor</h4>
                  <div className="text">
                    203, Shaheed Syed Nazrul Islam Sarani, Dhaka.
                    <br />
                    01755636267, 029553263
                    <br />
                    chungwah@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Mirpur-01</h4>
                  <div className="text">
                    Mirpur New Market, VTCB Tower (5 th floor) 3, Main Road,
                    Mirpur-1, Dhaka 1216
                    <br />
                    01709678135, 01709678146
                    <br />
                    xinxian.mirpur1@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Shimanto Convention Centre, Rifles Square, Dhanmondi</h4>
                  <div className="text">
                    75, Bir Uttom M A Rob Road, 4th Floor, Shimanto Square
                    Market, Dhaka
                    <br />
                    01755636268, 01755636321
                    <br />
                    shimanto@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Zam Zam Convention Hall, Mirpur-01</h4>
                  <div className="text">
                    Mirpur New Market, VTCB Tower (4 th floor), 3, Main Road,
                    Mirpur-1, Dhaka 1216
                    <br />
                    01709678145, 01709678146
                    <br />
                    zamzam@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Zam Zam Convention Hall, Mirpur-11</h4>
                  <div className="text">
                    Section-7, Main Road-03, Avenue-4, Plot-1/1, Pallabi,
                    Mirpur, Dhaka.
                    <br />
                    01709678171, 01709678172
                    <br />
                    zamzam.mirpur@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>X-group Catering</h4>
                  <div className="text">
                    House No. 59/A, Sheikh Kamal Sharani, Road No. 16, Dhanmondi
                    Dhaka- 1209
                    <br />
                    01755636335, 01755636336
                    <br />
                    catering@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Four Seasons Restaurant, Mirpur-11</h4>
                  <div className="text">
                    Section: 07, Main Road-3, Avenue: 4, Plot: 1/1 (2nd Floor)
                    Pallabi, Mirpur, Dhaka-1216
                    <br />
                    01709678170, 01709678171
                    <br />
                    4season@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xian Restaurant</h4>
                  <div className="text">
                    Xian Restaurant, 212 New Elephant Rd, Dhaka 1205
                    <br />
                    016545898902
                    <br />
                    xianrestaurant212@gmail.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xenial Restaurant</h4>
                  <div className="text">
                    House no: 88, 365 রোড নং ২৭, Dhaka 1209
                    <br />
                    01458985868
                    <br />
                    xenialrestaurant@gmail.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Book;
